import { FunctionComponent, Fragment } from 'react';
import { IAppProps } from '../../../common/interface/IAppProvider';
import { useGlobalState } from '../../../common/context/AppContext';

export const ProgressBar: FunctionComponent<IAppProps> = (props: IAppProps): JSX.Element => {
  const hippoTexts = props.config.resourceBundles['onsa.travel.progressbar'].read();
  const { actualStep } = useGlobalState();

  if (actualStep === 0) {
    return <Fragment />;
  } else if (actualStep < 3 || props.pageType === 'receipt') {
    return (
      <Fragment>
        <div className="progress-bar-inner" />
      </Fragment>
    );
  } else {
    return (
      <Fragment>
        <div className={`progress-payment-bar-inner payment-step-${actualStep}`}>
          <InsuranceInformation label={hippoTexts['icon.plane.label'] || 'Valg af forsikring'} className=" semi" />
          <Basket
            label={hippoTexts['icon.basket.label']}
            className={actualStep === 3 ? ' active' : actualStep > 3 ? ' semi' : ' dimmed'}
          />
          <AboutYou
            label={hippoTexts['icon.identity.label']}
            className={actualStep === 4 ? ' active' : actualStep > 4 ? ' semi' : ' dimmed'}
          />
          <StartDate
            label={hippoTexts['icon.calendar.label']}
            className={actualStep === 5 ? ' active' : actualStep > 5 ? ' semi' : ' dimmed'}
          />
          <Payment
            label={hippoTexts['icon.payment.label']}
            className={actualStep > 5 && actualStep < 8 ? ' active' : actualStep > 6 ? ' semi' : ' dimmed'}
          />
          <Accept label={hippoTexts['icon.accept.label']} className={actualStep > 7 ? ' active' : ' dimmed'} />
        </div>
      </Fragment>
    );
  }
};

interface IIcon {
  label: string;
  className: string;
}
const InsuranceInformation = ({ label, className }: IIcon) => {
  return genericIcon(label, className, 'plane', '60', -6);
};

const Basket = ({ label, className }: IIcon) => {
  return genericIcon(label, className, 'basket', '50', 0);
};

const AboutYou = ({ label, className }: IIcon) => {
  return genericIcon(label, className, 'contacts', '71', 0);
};

const StartDate = ({ label, className }: IIcon) => {
  return genericIcon(label, className, 'cal', '50', -2);
};

const Payment = ({ label, className }: IIcon) => {
  return genericIcon(label, className, 'credit-cards', '71', 0);
};

const Accept = ({ label, className }: IIcon) => {
  return genericIcon(label, className, 'document-sign', '71', 0);
};

const genericIcon = (label: string, className: string, shape: string, size: string, top: number) => {
  return (
    <div className={`payment-wrapper${className}`}>
      <flos-icon class={`flos-icon icon-${shape}`} shape={shape} size={size} style={{ left: 0, top: top }} />
      <div className={`icon-text icon-text-${shape}`}>{label}</div>
    </div>
  );
};
